export const careerData = [
  {
    slug: "frontend-developer",
    title: "Frontend Developer",
    status: "open",
    posted: "21 June 2025",
    deadline: "21 July 2025",
    summary: "Join Cardplot's engineering team to build intuitive user interfaces for our web platforms and revolutionize cross-border payments in Africa.",
    sections: [
      {
        title: "Job Description",
        content: `<p>At Cardplot, our singular focus is revolutionizing cross-border payments to ensure every African can seamlessly connect to the global economy. Stories of prosperity in developed countries are often built on the foundation of financial access and infrastructure. In Africa, many dreams remain unrealized due to the barriers in sending or receiving payments across borders.</p>
        <p>Cardplot is changing this narrative—for good! Over the past few years, we've been transforming how individuals and businesses handle cross-border transactions. By empowering payment providers with cutting-edge technology, data, and services, we're helping them scale their operations and deliver seamless international payment experience.</p>
        <p>Top payment platforms and financial institutions, including Kredi Bank, Pecunia Payments, and GlobalSend, rely on Cardplot to power their cross-border payment solutions.</p>`
      },
      {
        title: "About the Frontend Engineering Role",
        content: `<p>The Cardplot Engineering team is seeking a skilled and innovative Frontend Engineer to help build intuitive user interfaces for our web platforms, including Pecunia. This role is perfect for someone who thrives in a growth-driven environment and is committed to delivering excellence in their work.</p>
        <p>Currently, Cardplot operates remotely and is expanding its footprint across Africa. However, at this time, we are only hiring employees based in Nigeria to maintain efficient management.</p>`
      },
      {
        title: "Responsibilities",
        content: `
          <ul>
            <li>Develop, maintain, and test frontend code.</li>
            <li>Research and implement the latest frontend technologies and best practices.</li>
            <li>Collaborate with team members to resolve issues and deliver solutions.</li>
            <li>Support the team in achieving project goals and meeting deadlines.</li>
            <li>Provide assistance with frontend-related support issues.</li>
            <li>Mentor and onboard new team members when necessary.</li>
          </ul>`
      },
      {
        title: "Requirements",
        content: `
          <ul>
            <li>Minimum of a 2:1 degree in any field.</li>
            <li>Strong proficiency in TypeScript.</li>
            <li>Advanced knowledge of HTML and CSS (SCSS).</li>
            <li>Experience with Git and version control systems like GitHub.</li>
            <li>Open to Nigerian residents only.</li>
          </ul>`
      },
      {
        title: "Competencies/Skills",
        content: `
          <ul>
            <li>Excellent verbal and written communication skills.</li>
            <li>Curious, driven, and growth-oriented.</li>
            <li>Analytical and problem-solving mindset.</li>
            <li>Creativity and resourcefulness.</li>
            <li>Strong time management skills.</li>
            <li>Willingness to learn and adapt.</li>
          </ul>`
      },
      {
        title: "Compensation Structure",
        content: `
          <ul>
            <li>Base pay.</li>
            <li>Performance-based incentives.</li>
            <li>Additional company benefits as defined by policy.</li>
          </ul>`
      }
    ]
  },
  {
    slug: "backend-developer",
    title: "Backend Developer",
    status: "closed",
    posted: "3 June 2025",
    deadline: "3 July 2025",
    summary: "Works on server-side logic and integrations.",
    sections: [
      {
        title: "Job Description",
        content: `<p>Works on server-side logic and integrations to support frontend apps.</p>`
      },
      {
        title: "About the Role",
        content: `<p>Join our backend team to build scalable and robust APIs for the platform.</p>`
      },
      {
        title: "Responsibilities",
        content: `
          <ul>
            <li>Build secure APIs</li>
            <li>Database management</li>
            <li>Collaborate with frontend teams</li>
          </ul>`
      },
      {
        title: "Requirements",
        content: `
          <ul>
            <li>Experience with Node.js or Laravel</li>
            <li>Knowledge of SQL/NoSQL databases</li>
            <li>Familiarity with cloud hosting and DevOps is a plus</li>
          </ul>`
      }
    ]
  }
];